import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { isEntityLocked } from 'common/utils/isEntityLocked'

export const isLockedDescendant = (
  entity: EntityTypeEnum,
  parentEntity?: EntityTypeEnum,
) => isEntityLocked(entity) || (parentEntity && isEntityLocked(parentEntity))
